import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Space, message } from 'antd';
import { jsPDF } from 'jspdf';
import { useAuth0 } from '@auth0/auth0-react';
import { LoadingOutlined } from '@ant-design/icons';

interface Empresa {
  id: number;
  razon: string;
  direccion: string;
  localidad: string;
  provincia: string;
}

interface Sucursal {
  id: number;
  descripcion: string;
  localidad: string;
  provincia: string;
}

interface Comprobantes {
  id: number;
  nro_comprobante: string;
  fecha_emision: string;
  motor_nombre: string;
  equipo_nombre: string;
  sector_nombre: string;
  retiro_nombre: string;
  observacion: string;
  tipo: string;
  alta: number;
}

interface Movimientos {
  id: number;
  insumo: string;
  cantidad: number;
  precio_unitario: number;
  subtotal: number;
}

interface DataState {
  empresa: Empresa;
  sucursal: Sucursal;
  comprobantes: Comprobantes;
  movimientos: Movimientos[];
}

const ImprimirEgresos: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const {user, getAccessTokenSilently, isLoading} = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;

  const [data, setData] = useState<DataState>({
    empresa: {} as Empresa,
    sucursal: {} as Sucursal,
    comprobantes: {} as Comprobantes,
    movimientos: [],
  });
  console.log('data',data)
  const [loading, setLoading] = useState(false);
  const [isDataLoading, setIsDataLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (isLoading || !empresa || !id) return; // Verificar que tengamos empresa e id
      
      setIsDataLoading(true);
      setLoading(true);
      
      try {
        const token = await getAccessTokenSilently();
        const ruta = `${process.env.REACT_APP_INSUMOS_URL}/comprobantes_egreso/${empresa}/${sucursal}/${id}`;
        console.log('Fetching data from:', ruta);
        
        const response = await fetch(ruta, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const jsonData = await response.json();
        console.log('Received data:', jsonData); // Debug log
        setData(jsonData);
      } catch (error) {
        console.error('Error fetching data:', error);
        message.error('Error al obtener los datos del comprobante');
      } finally {
        setLoading(false);
        setIsDataLoading(false);
      }
    };

    fetchData();
  }, [id, isLoading, empresa, getAccessTokenSilently]);

  const exportToPDF = () => {
    const doc = new jsPDF();
    let yEmpresa = 20;  // Para los datos de empresa
    let yTitulo = 20;   // Para el título y fechas
    const lineHeight = 7;
    const pageWidth = doc.internal.pageSize.width;
    const leftMargin = 14;
    const rightMargin = pageWidth - 14;
    console.log('data.comprobantes',data.comprobantes)
    const empresa = data.empresa;
    if (empresa) {
      // Columna izquierda: Datos de empresa
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text(empresa.razon || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Resto de datos de empresa debajo de razón
      doc.setFont('helvetica', 'normal');
      doc.text(empresa.direccion || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;
      doc.text(empresa.localidad || '', leftMargin, yEmpresa);
      // Nº de orden en línea separada
     // yEmpresa += lineHeight;
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      console.log('data.comprobantes?.nro_comprobante',data.comprobantes.nro_comprobante);
      doc.text(`${data.comprobantes.nro_comprobante || ''}`, pageWidth/2, yEmpresa, { align: 'center' });
      
      yEmpresa += lineHeight;
      doc.setFont('helvetica', 'normal');
      doc.text(empresa.provincia || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Línea debajo de provincia
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight;

      // Datos de sucursal centrados
      const sucursal = data.sucursal;
      if (sucursal) {
        // Construir el texto completo de sucursal
        doc.setFont('helvetica', 'bold');
        const labelSucursal = 'Sucursal: ';
        
        doc.setFont('helvetica', 'normal');
        const direccionText = sucursal.descripcion || '';
        const ubicacionText = `${sucursal.localidad || ''} - ${sucursal.provincia || ''}`;
        const textoCompleto = `${labelSucursal}${direccionText}, ${ubicacionText}`;

        // Centrar todo el texto
        doc.text(textoCompleto, pageWidth/2, yEmpresa, { align: 'center' });
        yEmpresa += lineHeight;
      }

      // Segunda línea debajo de los datos de sucursal
      doc.line(leftMargin, yEmpresa, rightMargin, yEmpresa);
      yEmpresa += lineHeight * 1.5;

      // Datos del proveedor
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      const DatoSECTOR = 'SECTOR '
      doc.text(DatoSECTOR, leftMargin, yEmpresa);
      doc.setFont('helvetica', 'normal');
      doc.text(data.comprobantes.sector_nombre || '', leftMargin+20, yEmpresa);
      yEmpresa += lineHeight;
      doc.setFont('helvetica', 'bold');
      const DatoEQUIPO = 'EQUIPO '
      doc.text(DatoEQUIPO, leftMargin, yEmpresa);
      doc.setFont('helvetica', 'normal');
      doc.text(data.comprobantes.equipo_nombre || '', leftMargin+20, yEmpresa);
      yEmpresa += lineHeight;
      doc.setFont('helvetica', 'bold');
      const DatoMOTOR = 'MOTOR '
      doc.text(DatoMOTOR, leftMargin, yEmpresa);
      doc.setFont('helvetica', 'normal');
      doc.text(data.comprobantes.motor_nombre || '', leftMargin+20, yEmpresa);
      yEmpresa += lineHeight * 1.5;

      // Datos del proveedor en vertical con labels
      doc.setFont('helvetica', 'normal');
      // Columna central: ORDEN COMPRA
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text('COMPROBANTE DE EGRESO', pageWidth/2, yTitulo, { align: 'center' });
      yTitulo += lineHeight; // Mover hacia abajo para el siguiente texto

      // Agregar el tipo de comprobante centrado
      const tipoComprobante = `TIPO[${data.comprobantes.tipo || ''}]`;
      doc.setFontSize(14);
      doc.text(tipoComprobante, pageWidth/2, yTitulo, { align: 'center' });
      yTitulo += lineHeight * 2; // Aumentar el espacio después del tipo

      yTitulo += lineHeight * 2; // Aumentar el espacio después del título

      // Columna derecha: Fechas
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      const fechaGeneracion = new Date().toLocaleDateString('es-AR');
      doc.text(`Fecha Generación: ${fechaGeneracion}`, rightMargin, 20, { align: 'right' });
      
      const fechaEmision = data.comprobantes?.fecha_emision || '';
      doc.text(`Fecha Emisión: ${fechaEmision}`, rightMargin, 20 + lineHeight, { align: 'right' });
      // Título de Detalle de Insumos centrado
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('DETALLE DE INSUMOS', pageWidth/2, yEmpresa, { align: 'center' });
      yEmpresa += lineHeight;
      //
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, rightMargin-20, yEmpresa);
      yEmpresa += lineHeight;

      // Headers de la grilla
      doc.setFontSize(10);
      doc.setFont('helvetica', 'bold');
      doc.text('Detalle Insumos', 14, yEmpresa);
      doc.text('Cantidad', 70, yEmpresa);
      doc.text('Precio Unitario', 90, yEmpresa);
      doc.text('Subtotal', 130, yEmpresa);
      yEmpresa += lineHeight;

      // Línea debajo de los labels
      doc.setLineWidth(0.2);
      doc.line(leftMargin, yEmpresa, rightMargin-20, yEmpresa);
      yEmpresa += lineHeight;

      // Función para formatear números con separador de miles
      const formatNumber = (num: number): string => {
        return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      };

      // Función para convertir número a letras
      const numeroALetras = (numero: number): string => {
        const unidades = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
        const decenas = ['', 'DIEZ', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA', 'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA'];
        const especiales = ['ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE', 'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE'];
        const centenas = ['', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS', 'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS'];

        const procesarMiles = (n: number): string => {
          if (n === 0) return '';
          let result = '';
          
          // Procesar millones
          const millones = Math.floor(n / 1000000);
          if (millones > 0) {
            if (millones === 1) {
              result += 'UN MILLON ';
            } else {
              result += `${numeroALetras(millones)} MILLONES `;
            }
            n = n % 1000000;
          }

          // Procesar miles
          const miles = Math.floor(n / 1000);
          if (miles > 0) {
            if (miles === 1) {
              result += 'MIL ';
            } else {
              result += `${numeroALetras(miles)} MIL `;
            }
            n = n % 1000;
          }

          // Procesar centenas
          const centena = Math.floor(n / 100);
          if (centena > 0) {
            if (centena === 1 && n % 100 === 0) {
              result += 'CIEN ';
            } else {
              result += `${centenas[centena]} `;
            }
            n = n % 100;
          }

          // Procesar decenas y unidades
          if (n > 0) {
            if (n < 10) {
              result += `${unidades[n]} `;
            } else if (n < 20) {
              result += `${especiales[n - 11]} `;
            } else {
              const decena = Math.floor(n / 10);
              const unidad = n % 10;
              if (unidad === 0) {
                result += `${decenas[decena]} `;
              } else {
                result += `${decenas[decena]} Y ${unidades[unidad]} `;
              }
            }
          }

          return result;
        };

        if (numero === 0) return 'CERO';
        return procesarMiles(numero);
      };

      // Movimientos con verificación de números
      doc.setFont('helvetica', 'normal');
      let totalGeneral = 0;  // Variable para acumular el total

      data.movimientos.forEach(mov => {
        doc.text(`${mov.insumo}`, 14, yEmpresa);
        doc.text(`${mov.cantidad || 0}`, 76, yEmpresa,{ align: 'right' });
        
        // Precio unitario alineado a la derecha
        const precioText = `$ ${formatNumber(mov.precio_unitario || 0)}`;
        doc.text(precioText, 110, yEmpresa, { align: 'right' });
        
        // Calcular total con verificación de valores undefined
        const subtotal = mov.subtotal || 0;
        totalGeneral += subtotal;
        doc.text(`${subtotal}`, 145, yEmpresa, { align: 'right' });
        // Subtotal alineado a la derecha
        const totalText = `$ ${formatNumber(totalGeneral)}`;
       // doc.text(totalText, 190, yEmpresa, { align: 'right' });
        
       // doc.text(mov.fecha_entrega || '', 180, yEmpresa);
        yEmpresa += lineHeight;
      });

      // Línea después de la grilla de insumos
      doc.line(leftMargin, yEmpresa, rightMargin-20, yEmpresa);
      yEmpresa += lineHeight;

      // Total General alineado a la derecha
      doc.setFont('helvetica', 'normal');
      doc.text('Total:', 100, yEmpresa);
      const totalGeneralText = `$ ${formatNumber(totalGeneral)}`;
      doc.text(totalGeneralText, 145, yEmpresa, { align: 'right' });
      yEmpresa += lineHeight * 2;  // Espacio adicional antes del texto en letras

      
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      
      // Título de Forma de Pago y Autorización en la misma línea
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('RETIRO:', leftMargin, yEmpresa);
    //  doc.text('AUTORIZACIÓN:', pageWidth/2 + 10, yEmpresa);
      yEmpresa += lineHeight;
      doc.setFont('helvetica', 'normal');
      doc.text(data.comprobantes.retiro_nombre || '', leftMargin, yEmpresa);
      yEmpresa += lineHeight*2;
      doc.setFont('helvetica', 'bold');
      doc.text('OBSERVACIONES:', leftMargin, yEmpresa);
      yEmpresa += lineHeight;
      doc.setFont('helvetica', 'normal');
      doc.text(data.comprobantes.observacion || '', leftMargin, yEmpresa);
      doc.setFontSize(10);
      doc.setFontSize(12);
      const totalEntero = Math.floor(totalGeneral);
      const centavos = Math.round((totalGeneral - totalEntero) * 100);
      const importeEnLetras = numeroALetras(totalEntero).trim(); 
      doc.setFontSize(10);
      yEmpresa += lineHeight*2;     // Primera línea alineada al margen izquierdo
      doc.setFont('helvetica', 'bold');
      doc.text('Son Pesos:', leftMargin, yEmpresa);
      yEmpresa += lineHeight;
      doc.setFont('helvetica', 'normal');
       // Segunda línea (importe en letras y centavos) sin indentación
       doc.text(`${importeEnLetras} CON ${centavos.toString().padStart(2, '0')}/100`, leftMargin, yEmpresa);
       yEmpresa += lineHeight * 2;
      const nombreArchivo = `CI-${data.comprobantes?.nro_comprobante || 'sin_numero'}.pdf`;
      doc.save(nombreArchivo);
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      {isDataLoading ? (
        <div style={{ textAlign: 'center' }}>
          <LoadingOutlined style={{ fontSize: 24 }} spin />
          <p>Cargando datos...</p>
        </div>
      ) : (
        <>
          <div style={{ textAlign: 'center', marginBottom: '20px' }}>
            <h3>
                {data.comprobantes?.nro_comprobante 
                ? `Nº ${data.comprobantes.nro_comprobante}` 
                : 'Sin número'}
            </h3>
          </div>
          
          <Space>
            <Button 
              onClick={exportToPDF}
              loading={loading}
              disabled={!data.comprobantes?.nro_comprobante}
            >
              Exportar a PDF
            </Button>
          </Space>
        </>
      )}
    </div>
  );
};

export default ImprimirEgresos; 